import { h as __h } from "preact";
import { Component } from "preact";
import html from "~/util/html.js";
import Icon from "~/component/Icon.js";
import adminStyle from "~/admin/lib/style.js";
/** @import { locationResponse } from "~/backend/validate.js"; */

/**
 * @extends {Component<Props>}
 *
 * @typedef {object} Props
 * @property {Pick<locationResponse, "id" | "org_id" | "name">} location
 */
export default class LocationChip extends Component {
  render() {
    const {
      location
    } = this.props;
    return __h("a", {
      href: "/org/" + location.org_id + "/relays/" + location.id,
      "class": adminStyle.chip
    }, __h(Icon, {
      name: "antenna",
      size: 12
    }), __h("span", {}, location.name));
  }
}